import request from '@/api/request'
/*
    订单
    */
const getOrderlist = (params) => {
    return request({
        url: '/api/v1/app/item/items/pagingOrderInfo',
        method: 'GET',
        params
    })
}

/*
用户基本信息
*/
const getUserInfo = () => {
    return request({
        url: '/api/v1/cuz/user/info',
        method: 'GET',
        domain: 'mallUser'
    })
}
/*
维护用户信息
*/
const changeInfo = (data) => {
    return request({
        url: '/api/v1/cuz/user/update',
        method: 'POST',
        data,
        domain: 'mallUser'
    })
}

const upLoad = (data) => {
    return request({
        url: '/api/v1/cuz/upload',
        method: 'POST',
        data,
        domain: 'mallUser'
    })
}

const upLoadImg = (data) => {
    return request({
        url: '/api/v1/cuz/upload',
        method: 'POST',
        data,
        domain: 'mall'
    })
}
export default {
    getOrderlist,
    changeInfo,
    upLoad,
    upLoadImg,
    getUserInfo
}
